import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Branch, Lookup, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { take, takeUntil } from "rxjs/operators";
import { AccVoucherDetail } from "src/app/backoffice/acc/models/accvoucherdetail.model";
import * as moment from "moment";
import { LocalStoreManager, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { AccVoucherHeader } from "src/app/backoffice/acc/models/accvoucherheader.model";
import { TrsVoucherHeader } from "src/app/backoffice/trs/models/trs-voucher-header.model";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { AccountingDocumentSettingMenuComponent } from "../accounting-document-setting-menu.component";
import { ContextMenuEnum } from "src/app/frontoffice/order/model/contextMenuenum";
import { Subject } from "rxjs";
import { TrsVoucherDetail } from "src/app/backoffice/trs/models/trs-voucher-detail.model";
import { AccountingDocumentSetting } from "../accounting-document-setting.model";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";

export class ConfirmDateValue {
  EndDate: Date;
  StartDate: Date;
  closeDialog: Function;
  FiscalYearId: number;
  BranchId: number;
  ErrorMessage: string;
  Voucher: AccVoucherHeader[] = [];
  TrsVoucher: TrsVoucherHeader[] = [];
  FilterDateList: Lookup[] = [];
}

@Component({
  selector: "ngx-accounting-document-form.component",
  templateUrl: "./accounting-document-form.component.html",
  styleUrls: ["./accounting-document-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountingDocumentFormComponent extends BaseFormComponent<ConfirmDateValue> {
  swipeGrid() {
    this.showAccountingDocument = !this.showAccountingDocument;
    this.formMenuContextVisible = !this.formMenuContextVisible;
  }
  DetailLedgerList: AccVoucherDetail[];
  TrsDetailLedgerList: TrsVoucherDetail[];
  accVoucherHeaderList: AccVoucherHeader[];
  trsVoucherHeaderList: TrsVoucherHeader[];
  sumDebit: any;
  sumCredit: any;
  gridColumns: form_control[];
  gridColumnsAccounting: form_control[];
  gridColumnsTrsVoucher: form_control[];
  BranchLookUp: Branch[] = [];
  showAccountingDocument: boolean = true;
  showReceiptPayment: boolean = false;
  accVoucerherDetailcolumns: form_control[];
  DateNow: string;
  remaining: number;
  autoCancel = true;
  SoftWareLicenseKind = SoftWareLicenseKind;
  public contextmenuEnum: typeof ContextMenuEnum = ContextMenuEnum;
  settingChanges$ = new Subject();
  formMenuContextVisible = false;
  menu = AccountingDocumentSettingMenuComponent;
  accountingDocumentSetting: AccountingDocumentSetting;
  unSortableFilterable: string[] = [];
  currentInformation = this.accountService.authService.currentInformation();
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    public storage: LocalStoreManager,
    private splashFormService: SplashFormService,
    _id: FormContainerModel,
    _tabsservice: TabularService,
    public dialog: SimpleModalService
  ) {
    super(selectorService, cd);
    this._id = _id;
    const m = moment();
    this.DateNow = m.locale("fa").format("YYYY/MM/DD");
    this.tabsservice = _tabsservice;
  }

  async ngOnInit() {
    if (!this.label) this.label = "";
    this.apiName = "AccVoucherHeader";
    this.areaName = "";
    super.ngOnInit();
    this.GetAccColumns();
    this.GetTrsColumns();
    this.fillData();
    this.cd.markForCheck();
    this.showAccountingDocument = true;
    const columnsToExclude = [
      "RowNumber",
      "SubLedgerTitle",
      "SubLedgerCode",
      "DetailLedgerTitle",
      "DetailLedger2Title",
      "DetailLedger3Title",
      "DetailLedger4Title",
      "DetailLedger5Title",
      "DetailLedger6Title",
      "DetailLedger7Title",
      "DetailLedgerId",
      "SubLedgerId",
      "Debit",
      "Credit",
      "Comment",
      "TrackNo",
      "TrackDate",
      "TreasuryDetailLedgerCode",
      "TreasuryDetailLedgerTitle",
      "ConcernTitle",
      "Price",
    ];

    this.unSortableFilterable.push(...columnsToExclude);
  }
  AfterViewInit() {
    this.cd.detectChanges();
  }
  async setColumns() {}
  getSetting() {
    this.httpCommonService
      .getList("AccountingDocumentSetting")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any[]) => {
        if (result?.length > 0) {
          this.accountingDocumentSetting = result[0];
          this.storage.savePermanentData(result[0], "AccountingDocumentSetting");
        }
      });
  }

  async fillData(): Promise<void> {
    const data = await (<Promise<Branch[]>>this.httpCommonService.getList("Branch").pipe(take(1)).toPromise());
    this.setValue("StartDate", this.DateNow);
    this.setValue("EndDate", this.DateNow);
    this.setValue("BranchId", null);
    this.setValue("FilterDateList", null);
    const currentBranchId = this.accountService.authService.currentBranch?.Id;
    this.BranchLookUp = data.filter((x) => x.Id !== currentBranchId && x.IsActive);
    if (this.BranchLookUp != null || this.BranchLookUp.length == 0) {
      this.setValue("BranchId", this.BranchLookUp[0].Id);
    }
    this.cd.markForCheck();
  }

  GetAccColumns() {
    this.httpCommonService
      .getControlsList("CashierSettlemet/GetColumnInfo", true)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.gridColumnsAccounting = data as form_control[];
            const visibleListCols = ["SubLedgerTitle", "SubLedgerCode", "DetailLedgerTitle", "DetailLedger2Title", "DetailLedger3Title"];
            const nonVisibleListCols = [
              "DetailLedgerId",
              "SubLedgerId",
              "DetailLedger4Title",
              "DetailLedger5Title",
              "DetailLedger6Title",
              "DetailLedger7Title",
              "TrackNo",
              "TrackDate",
              "ModifiedUserName",
              "ShamsiModifiedDate",
              "CreatedUserName",
              "ShamsiCreatedDate",
            ];
            this.gridColumnsAccounting.forEach((x) => {
              x.formVisible = false;
              if (x.name.match(/^DetailLedger.Title$/g)) x.listVisible = true;
              if (visibleListCols.includes(x.name)) x.listVisible = true;
              if (nonVisibleListCols.includes(x.name)) x.listVisible = false;
              if (x.name.match(/^DetailLedger.Id$/g)) x.listVisible = false;
              if (x.name === "Debit") x.order = 2;
              if (x.name === "Credit") x.order = 2;
              if (x.name === "Comment") x.columnWidth = 400;
            });
            this.gridColumnsAccounting = this.gridColumnsAccounting.sort((a, b) => a.order - b.order);
          }
          this.cd.markForCheck();
        },
        (error) => {
          let errorMessage = Utilities.getHttpResponseMessage(error);
          if (errorMessage) {
            this.sts.showDialog(`${errorMessage}`, this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.ErrorMessage"));
          }
        }
      );
  }

  GetTrsColumns() {
    this.httpCommonService
      .getControlsList("CashierSettlemet/GetTrsVoucherDetailColumnInfo", true)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.getSetting();
            this.settingChanges$.pipe(take(1)).subscribe((x) => {
              this.getSetting();
            });

            const visibleCols = [, "ConcernTitle", "TreasuryDetailLedgerCode", "TreasuryDetailLedgerTitle"];

            const nonVisibleCols = [
              "TreasuryDetailLedgerId",
              "SubLedgerId",
              "ReferenceId",
              "DetailLedgerId",
              "DetailLedgerTitle",
              "SubLedgerTitle",
              "SubLedgerCode",
            ];

            const cols = data as form_control[];

            cols.forEach((x) => {
              x.formVisible = false;
              if (visibleCols.includes(x.name)) x.listVisible = true;
              if (nonVisibleCols.includes(x.name)) x.listVisible = false;
            });
            this.gridColumnsTrsVoucher = cols.sort((a, b) => a.order - b.order);
          }
          this.cd.markForCheck();
        },
        (error) => {
          let errorMessage = Utilities.getHttpResponseMessage(error);
          if (errorMessage) {
            this.sts.showDialog(`${errorMessage}`, this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.ErrorMessage"));
          }
        }
      );
  }

  GetList() {
    this.DetailLedgerList = [];
    this.TrsDetailLedgerList = [];
    this.accVoucherHeaderList = [];
    this.setValue("FilterDateList", null);
    let confirmDateValue = new ConfirmDateValue();
    confirmDateValue.StartDate = this.formGroup.controls["StartDate"].value;
    confirmDateValue.EndDate = this.formGroup.controls["EndDate"].value;
    confirmDateValue.BranchId = this.formGroup.controls["BranchId"].value;
    confirmDateValue.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.GettingInformation"));
    this.httpCommonService
      .create("CashierSettlemet/CreateAccountingVoucher", confirmDateValue)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: ConfirmDateValue) => {
          if (data.ErrorMessage) {
            this.sts.showDialog(data.ErrorMessage, "خطا");
            this.splashFormService.closeLoading();
          }
          if (data && data?.Voucher && data?.Voucher?.length > 0) {
            this.DetailLedgerList = data.Voucher[0].AccVoucherDetails;
            if (data?.FilterDateList?.length > 0) this.setValue("FilterDateList", data.FilterDateList[0].Id);
            this.accVoucherHeaderList = data.Voucher;
            this.trsVoucherHeaderList = data.TrsVoucher;
            this.TrsDetailLedgerList = data.TrsVoucher[0].TrsVoucherDetails;
            this.model.FilterDateList = data.FilterDateList;
            this.calcRemain();
            this.splashFormService.closeLoading();
            this.cd.markForCheck();
          }
          this.splashFormService.closeLoading();
          this.cd.markForCheck();
        },
        (error) => {
          let errorMessage = Utilities.getHttpResponseMessage(error);
          if (errorMessage) this.sts.showDialog(`${errorMessage}`, this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.ErrorMessage"));
          this.splashFormService.closeLoading();
        }
      );
      this.splashFormService.closeLoading();
  }

  async save() {
    let confirmDateValue = new ConfirmDateValue();
    confirmDateValue.StartDate = this.formGroup.controls["StartDate"].value;
    confirmDateValue.EndDate = this.formGroup.controls["EndDate"].value;
    confirmDateValue.BranchId = this.formGroup.controls["BranchId"].value;
    confirmDateValue.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
    confirmDateValue.Voucher = this.accVoucherHeaderList;
    confirmDateValue.TrsVoucher = this.trsVoucherHeaderList;
    this.httpCommonService
      .create("CashierSettlemet/SaveAccVoucher", confirmDateValue)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.closeForm(true);
          this.isClosing = false;
          this.submitted = true;
          this.sts.showToast(
            "success",
            this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.successful"),
            `${this.translate("ClientApp.FrontOffice.Financial.AccountingDocument.InformationChanges")}  ${this.label}  ${this.translate(
              "ClientApp.FrontOffice.Financial.AccountingDocument.SavedSuccessfully"
            )} `
          );
          this.result = true;
        },
        (error) => {
          let errorMessage = Utilities.getHttpResponseMessage(error);
          if (errorMessage) super.saveFailedHelper(error);
          this.isSaved = false;
          this.cd.markForCheck();
        }
      );
  }

  protected isCloseable(): boolean {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    return true;
  }

  async cancel() {
    this.close();
  }

  valueChange($event: any) {
    if ($event) {
      this.DetailLedgerList = this.accVoucherHeaderList[$event.Id].AccVoucherDetails;
      if (this.trsVoucherHeaderList?.length > 0) this.TrsDetailLedgerList = this.trsVoucherHeaderList[$event.Id].TrsVoucherDetails;
    } else this.DetailLedgerList = null;
    this.calcRemain();
  }
  calcRemain() {
    this.sumDebit = this.DetailLedgerList?.getSumWithKey("Debit");
    this.sumCredit = this.DetailLedgerList?.getSumWithKey("Credit");
    this.remaining = this.sumDebit - this.sumCredit;
  }
}
